import { X, Copy, Repeat2, ExternalLink } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'sonner';

export default function ShareModal({ open, onClose, postId }) {
  if (!open) return null;

  const shareUrl = `https://humaclub.com/post/${postId}`;
  const shareText = 'Check out this verified impact on HumaClub!';

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl).catch(() => {});
    toast.success('Link copied!');
    onClose();
  };

  const handleShareToFeed = () => {
    toast.success('Shared to your feed!');
    onClose();
  };

  const socialLinks = [
    { label: 'Twitter/X', url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`, color: 'bg-black' },
    { label: 'Facebook', url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, color: 'bg-[#1877F2]' },
    { label: 'WhatsApp', url: `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`, color: 'bg-[#25D366]' },
    { label: 'Email', url: `mailto:?subject=${encodeURIComponent('Verified Impact on HumaClub')}&body=${encodeURIComponent(shareText + '\n' + shareUrl)}`, color: 'bg-slate-600' },
  ];

  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/40" onClick={onClose}>
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="w-full max-w-sm bg-white rounded-xl shadow-2xl" onClick={e => e.stopPropagation()} data-testid="share-modal">
          <div className="flex items-center justify-between px-5 py-3 border-b border-slate-100">
            <h3 className="font-semibold text-sm text-slate-900">Share</h3>
            <button onClick={onClose} className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-slate-100"><X className="w-4 h-4 text-slate-400" /></button>
          </div>
          <div className="p-5 space-y-3">
            <button onClick={handleShareToFeed} className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 transition-colors text-left" data-testid="share-to-feed">
              <div className="w-9 h-9 rounded-full bg-[#7C3AED]/10 flex items-center justify-center"><Repeat2 className="w-4 h-4 text-[#7C3AED]" /></div>
              <div>
                <p className="text-sm font-medium text-slate-900">Share to your feed</p>
                <p className="text-xs text-slate-400">Repost with optional comment</p>
              </div>
            </button>
            <button onClick={handleCopyLink} className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 transition-colors text-left" data-testid="copy-link">
              <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center"><Copy className="w-4 h-4 text-slate-600" /></div>
              <div>
                <p className="text-sm font-medium text-slate-900">Copy link</p>
                <p className="text-xs text-slate-400">Share anywhere</p>
              </div>
            </button>
            <div className="pt-2 border-t border-slate-100">
              <p className="text-xs text-slate-400 mb-2">Share via</p>
              <div className="flex gap-2">
                {socialLinks.map(s => (
                  <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" className={`flex-1 py-2 rounded-lg text-white text-xs font-medium text-center ${s.color} hover:opacity-90 transition-opacity`} data-testid={`share-${s.label.toLowerCase()}`}>
                    {s.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
